export const textCrudelang = `
 ██████╗██████╗ ██╗   ██╗██████╗ ███████╗██╗      █████╗ ███╗   ██╗ ██████╗
██╔════╝██╔══██╗██║   ██║██╔══██╗██╔════╝██║     ██╔══██╗████╗  ██║██╔════╝
██║     ██████╔╝██║   ██║██║  ██║█████╗  ██║     ███████║██╔██╗ ██║██║  ███╗
██║     ██╔══██╗██║   ██║██║  ██║██╔══╝  ██║     ██╔══██║██║╚██╗██║██║   ██║
╚██████╗██║  ██║╚██████╔╝██████╔╝███████╗███████╗██║  ██║██║ ╚████║╚██████╔╝
 ╚═════╝╚═╝  ╚═╝ ╚═════╝ ╚═════╝ ╚══════╝╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝
`;
